export default __webpack_public_path__ + "static/media/postgresql-icon.91181e9e.svg";